import React from "react";

export default function WebsitePreview({ url }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        margin: "1rem 0",
      }}
    >
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          textDecoration: "none",
        }}
      >
        <div
          style={{
            width: "320px",
            height: "180px",
            border: "1px solid #ccc",
            borderRadius: "10px",
            background: "#fff",
            overflow: "hidden",
            position: "relative",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
          }}
        >
          <iframe
            src={url}
            title={`Preview of ${url}`}
            scrolling="no"
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              width: "200%",
              height: "200%",
              border: "none",
              transform: "scale(0.5)",
              transformOrigin: "top left",
              pointerEvents: "none",
              overflow: "hidden",
            }}
          />
        </div>
      </a>
    </div>
  );
}
